module.exports = __webpack_public_path__ + "img/edit.3d8d7e3f.svg";